import React from "react";
import { useTranslation } from "react-i18next";
import { CheckCircleIcon, QuestionMarkCircleIcon } from "@heroicons/react/24/outline";

export default function CaseGuideSummaryCard({ run }) {
  const { t } = useTranslation();
  const questions = run?.template?.questions || [];
  const answers = run?.answers || {};
  const effects = run?.effects_applied || {};
  const automaticLabels = run?.automatic_labels || [];

  return (
    <div className="rounded-2xl border border-emerald-200 bg-gradient-to-br from-emerald-50 to-white p-5 shadow-sm">
      <div className="flex items-start gap-3">
        <div className="rounded-xl bg-emerald-100 p-2">
          <QuestionMarkCircleIcon className="h-6 w-6 text-emerald-700" />
        </div>
        <div className="min-w-0 flex-1">
          <div className="flex items-center justify-between gap-3">
            <div>
              <h3 className="text-base font-semibold text-gray-950">{run?.template?.title || t("Case guide")}</h3>
              <p className="text-xs text-gray-500">
                {run?.purpose === "request_info" ? t("Etterspurt info") : t("Guidet opprettelse")}
              </p>
            </div>
            <span className="inline-flex items-center gap-1 rounded-full bg-emerald-100 px-2.5 py-1 text-xs font-medium text-emerald-800">
              <CheckCircleIcon className="h-4 w-4" />
              {t("Besvart")}
            </span>
          </div>

          <div className="mt-4 grid grid-cols-1 gap-3 sm:grid-cols-2">
            {questions.map((question) => (
              <div key={question.key} className="rounded-lg border border-gray-100 bg-white p-3">
                <p className="text-xs font-medium text-gray-500">{question.label}</p>
                <p className="mt-1 text-sm text-gray-900">{formatAnswer(question, answers[question.key]) || "–"}</p>
              </div>
            ))}
          </div>

          {(automaticLabels.length > 0 || effects?.tag_ids?.length > 0) && (
            <div className="mt-4 rounded-lg border border-emerald-200 bg-emerald-50 p-3 text-xs text-emerald-800">
              <p className="font-medium">{t("Automatiske etiketter lagt til")}</p>
              {automaticLabels.length > 0 ? (
                <div className="mt-2 flex flex-wrap gap-1.5">
                  {automaticLabels.map((label) => (
                    <span
                      key={label.id}
                      className="inline-flex items-center rounded-full bg-white px-2 py-0.5 text-xs font-medium text-emerald-800 ring-1 ring-emerald-200"
                    >
                      {label.name || label.displayTitle}
                    </span>
                  ))}
                </div>
              ) : (
                <p className="mt-1">{t("Antall")}: {effects.tag_ids.length}</p>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

function formatAnswer(question, value) {
  if (value === undefined || value === null || value === "") return "";
  const options = question.options || [];
  if (Array.isArray(value)) {
    return value.map((item) => options.find((option) => option.value === item)?.label || item).join(", ");
  }
  if (typeof value === "boolean") return value ? "Ja" : "Nei";
  return options.find((option) => option.value === value)?.label || value;
}
